import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

const routes = [
  { path: '/', redirect: '/dashboard' },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
  },

  // Participant routes
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/DashboardPage.vue'),
  },
  {
    path: '/sessions',
    name: 'sessions',
    component: () => import('@/pages/sessions/SessionListPage.vue'),
  },
  {
    path: '/sessions/:id',
    name: 'session-detail',
    component: () => import('@/pages/sessions/SessionDetailPage.vue'),
  },
  {
    path: '/sessions/:id/vote',
    name: 'session-vote',
    component: () => import('@/pages/voting/VotePage.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/pages/profile/ProfilePage.vue'),
  },
  {
    path: '/my-debates',
    name: 'my-debates',
    component: () => import('@/pages/debates/MyDebatesPage.vue'),
  },
  {
    path: '/my-debates/:pairingId',
    name: 'debate-detail',
    component: () => import('@/pages/debates/DebateDetailPage.vue'),
  },

  // Admin routes
  {
    path: '/admin',
    name: 'admin-dashboard',
    component: () => import('@/pages/admin/AdminDashboardPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('@/pages/admin/users/UserListPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/users/:id',
    name: 'admin-user-detail',
    component: () => import('@/pages/admin/users/UserDetailPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/topics',
    name: 'admin-topics',
    component: () => import('@/pages/admin/topics/TopicListPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/topics/create',
    name: 'admin-topic-create',
    component: () => import('@/pages/admin/topics/TopicFormPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/topics/:id/edit',
    name: 'admin-topic-edit',
    component: () => import('@/pages/admin/topics/TopicFormPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/sessions',
    name: 'admin-sessions',
    component: () => import('@/pages/admin/sessions/AdminSessionListPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/sessions/create',
    name: 'admin-session-create',
    component: () => import('@/pages/admin/sessions/SessionFormPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/sessions/:id',
    name: 'admin-session-detail',
    component: () => import('@/pages/admin/sessions/AdminSessionDetailPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/sessions/:id/voting',
    name: 'admin-voting-results',
    component: () => import('@/pages/admin/voting/VotingResultsPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/sessions/:id/pairing',
    name: 'admin-pairing',
    component: () => import('@/pages/admin/pairing/PairingPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/pairing-history',
    name: 'admin-pairing-history',
    component: () => import('@/pages/admin/pairing/PairingHistoryPage.vue'),
    meta: { requiresAdmin: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const authStore = useAuthStore()

  // Allow navigation during rehydration (don't bounce to login)
  if (authStore.isRehydrating) return

  if (to.name !== 'login' && !authStore.isLoggedIn) {
    return { name: 'login' }
  }

  if (to.meta.requiresAdmin && !authStore.isAdmin) {
    return { name: 'dashboard' }
  }
})

export default router
